import { render, staticRenderFns } from "./CollectionModel.vue?vue&type=template&id=436bb232&scoped=true&"
import script from "./CollectionModel.vue?vue&type=script&lang=js&"
export * from "./CollectionModel.vue?vue&type=script&lang=js&"
import style0 from "./CollectionModel.vue?vue&type=style&index=0&id=436bb232&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "436bb232",
  null
  
)

export default component.exports